import React from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import loadContent from "core-module/hoc/loadContent";

import LoadingBox from "common/components/LoadingBox";

import PhoneByBillingpackage from "./PhoneByBillingpackage.jsx";
import BillingPackageSelectCard from "./BillingPackageSelectCard.jsx";
import NoPhoneAccount from "./NoPhoneAccount.jsx";

class Phone extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBillingPackage: 0,
      selectedEmergencyProfile: 0,
      voipBpsId: 0,
      loading: false
    };

    this.billingpackageList = this.props.getList((oGet, id) => id);
    this.emergencyprofileType = {};
    this.props.getList((oGet, id) => {
      this.emergencyprofileType[id] = oGet("emergencyprofile_type");
    });
  }

  //Wizard/Screen Rendering control

  handleSelectBillingPackage = event => {
    this.setState({ selectedBillingPackage: event.target.value });
  };

  closeWizard = () => this.setState({ wizard: null });

  //Data/API Events

  render() {
    if (this.state.loading) {
      return <LoadingBox />;
    }

    if (
      this.billingpackageList == null ||
      this.billingpackageList.length === 0
    ) {
      return (
        <GridContainer justify="center">
          <GridItem key="noVoip" xs={12}>
            <NoPhoneAccount />
          </GridItem>
        </GridContainer>
      );
    }

    const bpid = this.billingpackageList[this.state.selectedBillingPackage];
    return (
      <GridContainer justify="center">
        {this.billingpackageList.length === 1 ? null : (
          <GridItem key="selectbpid" xs={12}>
            <BillingPackageSelectCard
              selectedBillingPackage={this.state.selectedBillingPackage}
              handleSelect={this.handleSelectBillingPackage}
              billingpackageList={this.billingpackageList}
            />
          </GridItem>
        )}
        <GridItem xs={12}>
          <PhoneByBillingpackage
            pathids={{
              billingpackage: bpid
            }}
            shouldRender="CallHistory"
          />
        </GridItem>
      </GridContainer>
    );
  }
}

export default loadContent("user.session/billingpackage_voip", Phone);
